/**
 * The advertising "campaign" the visitor is coming from
 * @module
 */
var BrowserSource = require('core/utils/browser');

module.exports = {
  provides: 'campaign',
  shouldTrack: true,

  // If no campaign is known fall back to previously determined value
  isSticky: true,

  getter: [
    /**
     * Get the value of the "utm_campaign" query param
     * @returns {string|undefined}
     */
    function() {
      return BrowserSource.getQueryParamValue('utm_campaign');
    }
  ],
};
